import { IOrderItem, Order, OrderStatus, OrderType } from "@/models";
import { ethers } from "ethers";
import APP_ASSETS from "@/assets";
import { formatTimestamp } from "@/lib/utils";
import { ICONS } from "@/assets/icons";
import { OrderDrawer } from "./OrderDrawer.tsx";
import { Skeleton } from "./ui/skeleton";
import { useState } from "react";

export const ActiveOrderItem = ({ ...order }: IOrderItem) => (
  <div className="flex w-full items-center justify-between gap-2 rounded-md border-[0.1px] border-[#FFFFFF00] py-2 hover:border-[0.1px] hover:border-primary">
    <div className="flex items-center justify-between gap-2">
      {order.orderType === OrderType.SELL ? (
        <div className="h-10 w-10 rounded-full border-[0.1px] border-[#FFFFFF33] p-2">
          <img src={ICONS.SEND_RUPEE} />
        </div>
      ) : (
        <div className="h-10 w-10 rounded-full border-[0.1px] border-[#FFFFFF33] p-2">
          <img src={ICONS.RECEIVE_RUPEE} />
        </div>
      )}
      <div className="flex flex-col items-start">
        <div className="flex items-start">
          <p className="w-[80px] whitespace-nowrap text-start text-sm font-medium tracking-wide text-text-light">
            {order.orderType === OrderType.SELL ? "Send" : "Receive"} INR
          </p>
          <div className="mx-2 flex items-center justify-center rounded-sm bg-red-500 px-1">
            <p className="text-[10px] font-medium tracking-widest text-black">
              {OrderStatus[order.status]}
            </p>
          </div>
        </div>
        <p className="font-satoshiBold text-sm tracking-wide text-gray-400">
          Order ID: {order.id}
        </p>
      </div>
    </div>
    <div className="flex gap-2">
      <div className="flex flex-col items-end justify-between">
        <div className="flex gap-1">
          <p className="font-satoshiBold text-text-light">
            {Math.round(Number(ethers.utils.formatUnits(order.fiatAmount, 6)))
              .toFixed(2)
              .toString()}
          </p>
          <img src={APP_ASSETS.TOKENS.INR_TRANSPARENT} alt="INR" />
        </div>
        <p className="font-satoshiBold text-[12px] tracking-wide text-gray-400">
          {formatTimestamp(order.placedTimestamp)}
        </p>
      </div>
    </div>
  </div>
);

export const ActiveOrders = ({
  activeOrders,
  ordersLoading,
  ordersFetched,
}: {
  activeOrders: Order[];
  ordersLoading: boolean;
  ordersFetched: boolean;
}) => {
  const [openedOrder, setOpenedOrder] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <div className="mt-6 px-6">
      <div className="flex w-full items-center justify-between pb-2">
        <p className="text-md font-bold leading-5 tracking-wider text-text-light">
          {`Active Order${activeOrders?.length == 1 ? "" : "s"} ${activeOrders?.length > 0 ? `(${activeOrders.length})` : ""} `}
        </p>
      </div>
      <div className="bg-green hide-scroll flex h-[350px] w-full flex-col gap-4 overflow-scroll">
        {ordersLoading ? (
          <>
            <Skeleton className="h-14 w-full" />
            <Skeleton className="h-14 w-full" />
            <Skeleton className="h-14 w-full" />
          </>
        ) : (
          <>
            {ordersFetched &&
              activeOrders.map((order: any, idx: any) => (
                <div
                  className="hover:cursor-pointer"
                  onClick={() => {
                    setOpenedOrder(order);
                    setDrawerOpen(true);
                  }}>
                  <ActiveOrderItem key={idx} {...order} />
                </div>
              ))}
          </>
        )}
      </div>
      {openedOrder && (
        <OrderDrawer
          order={openedOrder}
          autoOpen={drawerOpen}
          onClose={() => {
            setDrawerOpen(false);
          }}
          archived={false}
        />
      )}
    </div>
  );
};
